import { MOQS, GET_MOQ, FETCH_MORE_MOQS, SEARCHED_MOQS } from '../types/index';

const initialState = {

    data: [],

    moq: {},

    pages: null,

    page: 1,

    next_page: null

};

export default function(state = initialState, action) {

    switch(action.type) {

        case MOQS: 

            return {

                ...state,

                data: action.payload.data,

                pages: action.payload.pages,

                page: action.payload.page,

                next_page: action.payload.next_page

            };

        case FETCH_MORE_MOQS: 

            return {

                ...state,

                data: state.data.concat(action.payload.data),

                pages: action.payload.pages,

                page: action.payload.page,

                next_page: action.payload.next_page

            };

        case GET_MOQ: 

            return {

                ...state,

                moq: action.payload

            };

        case SEARCHED_MOQS: 

            return {

                ...state,

                data: action.payload,

                pages: null,

                page: 1,

                next_page: null

            };

        default:

            return state;

    }

};